import { string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Editorial from 'shared/components/content/Editorial';
import HTMLContent from 'shared/components/HTMLContent';
import { getText } from 'shared/utils/Text';

import Article from './Article';

const Article6 = ({ title, body }) => (
  <Article index="6">
    <h1>{title}</h1>
    <Editorial>
      <HTMLContent content={body} />
    </Editorial>
    <Link to="/instruktionsfilmer" className="action-button">
      {getText('calendar-all-instructions')}
    </Link>
  </Article>
);

Article6.propTypes = {
  title: string.isRequired,
  body: string,
};

export default Article6;
